import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";
import AdvancePaymentProofRequiredErrorResponse from "./AdvancePaymentProofRequiredErrorResponse";

export default class MarkOrderAsPendingErrorResponse extends ApiErrorResponse {
    static errorCodes() {
        return [];
    }

    static understandThis(jsonResponse) {
        const hasErrors = jsonResponse.errors && jsonResponse.errors.length > 0;
        if (!hasErrors) return false;
        const code = jsonResponse.errors[0].code;
        return !AdvancePaymentProofRequiredErrorResponse.errorCodes().includes(code);
    }

    isAdvancePaymentRequiredError() {
        return false;
    }
}
